export default __webpack_public_path__ + "static/media/liveness.67773b30.png";